import TERMINAL_PLATFORMS_VARIABLES from './terminal-platforms-variables';

export default {
  mt: 'MT4',
  mt5: 'MT5',
  [TERMINAL_PLATFORMS_VARIABLES.MT4]: 'MetaTrader 4',
  [TERMINAL_PLATFORMS_VARIABLES.MT5]: 'MetaTrader 5',
  [TERMINAL_PLATFORMS_VARIABLES.MT5_DEMO]: 'MetaTrader 5 Demo',
};
